import { useRender } from "@base-ui-components/react/use-render";
import { mergeProps } from "@base-ui-components/react/merge-props";
import { containerClasses, ContainerVariants } from "./Container.style";

export type ContainerProps = useRender.ComponentProps<"div"> &
  ContainerVariants;

const Container = (props: ContainerProps) => {
  const { render, maxWidth, disableGutters, className, ...rest } = props;

  const element = render ?? <div />;

  const defaultProps: useRender.ElementProps<"div"> = {
    className: containerClasses({
      maxWidth,
      disableGutters,
      class: className,
    }),
  };

  const renderElement = useRender({
    render: element,
    props: mergeProps<"div">(defaultProps, rest),
  });

  return renderElement;
};

export default Container;
